module.exports = __webpack_public_path__ + "img/hero-top-right.64336d26.svg";